import './App.css';

import { useRoutes } from 'react-router-dom';
import Themeroutes from "./routes/Router";

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const routing = useRoutes(Themeroutes);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="app">{routing}</div>
    </LocalizationProvider>
  );
}

export default App;